<template>
  <b-card class="rectangle" style="height: 550px">
    <b-row>
      <b-col cols="8">
        <h4>
          {{ title }}
        </h4>
      </b-col>
      <b-col cols="12" class="d-flex align-items-center justify-content-end" stytle="width:100%" v-if="!error">
        <slot name="search" />
      </b-col>
    </b-row>
    <b-row>
      <div v-if="loaded && !error" class="col-lg-12 card-content m-0 mb-2 border-0 shadow-none">
        <apexchart
          :options="chartOptions"
          :series="series"
          class="apex-charts"
          dir="ltr"
          height="350"
          width="500"
          :type="type"
        ></apexchart>
      </div>
      <div v-if="error" class="w-100 py-4">
        <h3 class="d-flex justify-content-center align-items-center text-primary" style="height: 400px">
          <slot name="error"></slot>
        </h3>
      </div>
      <div
        v-if="!loaded && !error"
        class="d-flex justify-content-center align-items-center mt-5 w-100"
        style="height: 350px"
      >
        <b-spinner style="width: 3rem; height: 3rem" variant="primary"></b-spinner>
      </div>
    </b-row>
    <b-row v-if="footer && !error">
      <b-col cols="3"></b-col>
      <b-col cols="9">
        <h-e-rectangle :title="footer"></h-e-rectangle>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: 'chart',

  props: {
    title: {
      type: String,
      required: true,
    },
    loaded: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    chartOptions: {
      type: Object,
      required: true,
    },
    series: {
      type: Array,
      required: true,
    },
    footer: String,
    error: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped></style>
